import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../../ui';
import { AdfNodeProps } from './AdfModelTypes';

const InlineCard = styled.a`
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0 0.25rem;
    background-color: #f8f9fa;
    border: 1px solid ${Colors.border};
    border-radius: 0.25rem;
    color: #0052cc;
    text-decoration: none !important;
    font-size: 0.875rem;
    
    &:hover {
        background-color: #e9ecef;
    }

    &:before {
        z-index: -1;
        content: '';
        position: absolute;
        inset: 0;
        background: #0515240F;
        border-radius: .25rem;
    }
`;

const InlineCardIcon = styled.span`
    font-size: 0.75rem;
`;

const InlineCardText = styled.span`
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const AdfInlineCard = React.memo(({ node }: AdfNodeProps) => {
    const { url, data } = node.attrs || {};
    const linkUrl = url || data?.url;

    if (!linkUrl) return <span>Invalid card</span>;

    return (
        <InlineCard href={linkUrl} target="_blank" rel="noopener noreferrer">
            <InlineCardIcon>🔗</InlineCardIcon>
            <InlineCardText>{linkUrl}</InlineCardText>
        </InlineCard>
    );
});
